import 'jquery';

export class Foldout {
    static get CLASS() { return 'foldout-item'; }
    static get CLASS_TITLE() { return 'foldout-title'; }
    static get CLASS_DISABLE_COLLAPSE() { return 'foldout-disable-collapse'; }
    //private static CLASS_BUTTON = 'collapse-link';
    static get CLASS_CONTENT() { return 'foldout-content'; }
    static get CLASS_START_COLLAPSED() { return 'foldout-item-collapsed'; }
    static get CLASS_START_COLLAPSED_DIRTY() { return 'foldout-item-collapsed-dirty'; }
    static get CLASS_COLLAPSED() { return 'collapsed'; }

    /**
     * Collapses the content section of a foldout.
     *
     * @param {string} selector An element or selector matching a single foldout.
     * @param {bool} collapseInstantly A boolean signifying if the foldout should be collapsed instantly, or with an animation.
     */
    collapse(selector, collapseInstantly) {
        var $foldout = $(selector);
        var $title = $foldout.find('.' + Foldout.CLASS_TITLE);
        //var $buttonIcon = $foldout.find('.' + Foldout.CLASS_BUTTON + ' > i');
        var $content = $foldout.find('.' + Foldout.CLASS_CONTENT);

        var isCollapsed = $foldout.hasClass(Foldout.CLASS_COLLAPSED) ||
            $foldout.hasClass(Foldout.CLASS_START_COLLAPSED) && !$foldout.hasClass(Foldout.CLASS_START_COLLAPSED_DIRTY);
        var collapseIsDisabled = $foldout.hasClass(Foldout.CLASS_DISABLE_COLLAPSE) || $title.hasClass(Foldout.CLASS_DISABLE_COLLAPSE);

        if (!isCollapsed && !collapseIsDisabled) {
            if (collapseInstantly) {
                $content.hide();
                $foldout.addClass(Foldout.CLASS_COLLAPSED);

                /* Fire the resize event so listeners know the window has been resized */
                setTimeout(function () {
                    $foldout.resize();
                }, 50);
            } else {
                this._toggle($foldout, $content);
            }
        }
    }

    /**
    * Toggles the collapsed state a foldout.
    * @param {string} selector An element or selector matching a single foldout.
    */
    toggle(selector) {
        var $foldout = $(selector).first();

        if ($foldout.length > 0) {
            var $content = $foldout.find('.' + Foldout.CLASS_CONTENT);

            this._toggle($foldout, $content);
        }

    }

    _toggle($foldout, $content) {
        var $title = $foldout.find('.' + Foldout.CLASS_TITLE);

        var collapseIsDisabled = $foldout.hasClass(Foldout.CLASS_DISABLE_COLLAPSE) || $title.hasClass(Foldout.CLASS_DISABLE_COLLAPSE);
        if (!collapseIsDisabled) {

            $content.slideToggle(200);

            /* Initialize the foldout with the collapsed class if it's set to start out as collapsed,
             and it's opened for the first time. */
            if ($foldout.hasClass(Foldout.CLASS_START_COLLAPSED) &&
                !$foldout.hasClass(Foldout.CLASS_START_COLLAPSED_DIRTY)) {
                $foldout.addClass(Foldout.CLASS_COLLAPSED)
                    .addClass(Foldout.CLASS_START_COLLAPSED_DIRTY);
            }

            $foldout.toggleClass(Foldout.CLASS_COLLAPSED);

            setTimeout(function () {
                $foldout.resize();
                $foldout.find('[id^=map-]').resize();
            }, 50);
        }
    }
}